         'use strict';

         // var ServerRoot = 'http://localhost:8083/api/';
         // var ServerRoot = 'http://119.254.19.125:8086/api/';
         const IS_DEBUG = false; //如果是测试环境就是true，如果是生产环境就是false
         const commonUrl = IS_DEBUG ? 'api/' : '//api-mh.cnbooking.net/api/'
             //  const commonUrl = IS_DEBUG ? 'api/' : 'http://183.61.21.224:8035/api/'
             //  const commonUrl = IS_DEBUG ? 'api/' : '//183.61.21.248:8071/api/'
             // var ServerRoot = window.serverApi;

         module.exports = {
             //cnbooking api config
             login: commonUrl + 'Token',
             getHotelList: commonUrl + 'Hotels',
             getRoomsList: commonUrl + 'Rooms',
             getRp: commonUrl + 'RP',
             getRps: commonUrl + 'RP/GetRPs',
             updatePrice: commonUrl + 'RP/Price',
             //  batchState: commonUrl + 'RP/BatchState', //批量修改房态旧
             batchState: commonUrl + 'RP/BatchState/New', //批量修改房态
             setShare: commonUrl + 'RP/StockNum/New', //修改共享房态房量


             batchPrice: commonUrl + 'RP/BatchPrice', //批量修改价格
             updatePriceSingle: commonUrl + 'RP/Price', //修改价格
             //  updateStateSingle: commonUrl + 'RP/State', //修改房态旧
             updateStateSingle: commonUrl + 'RP/State/New', //修改房态
             getOrderList: commonUrl + 'Orders', //获取指定状态的订单列表
             getWaterList: commonUrl + 'Orders/SD', //根据订单号获取付款水单
             getOrderLogs: commonUrl + 'Orders/OrderLogs', //获取 订单日志
             updateConfrim: commonUrl + 'Orders/UpdateConfrim', //更新确认号
             checkStatus: commonUrl + 'Orders/SynchronizeCheckInOrderStatus', //更新

             getPaymentsByOrderNO: commonUrl + 'Orders/GetPaymentsByOrderNO', //根据订单号获取付款水单
             getPaymentsByOrderNO1: commonUrl + 'Orders/POST-api-Orders-SD', //根据订单号获取付款水单
             getPaymentsByPaymentID: commonUrl + 'Orders/GetPaymentsByPaymentID', //根据 paymentID 获取会款水单

             getExportEBOrders: commonUrl + 'Orders/ExportEBOrders', //导出
             getExportEBOrdersUrl: 'https://api-mh.cnbooking.net', //导出


             //用户中心
             getSubUserList: commonUrl + 'SubAccount/List', //获取子账号列表
             createSubUser: commonUrl + 'SubAccount/Create', //创建子账号
             eidtSubUser: commonUrl + 'SubAccount/Edit', //修改子账号信息
             updatePassword: commonUrl + 'Account/ChangePwd', //修改密码(主账号/子账号的修改都通过这个接口)
             getNotifyPhone: commonUrl + 'Account/NotifyPhone', //获取订单提醒短信接收手机号码
             getNotifyEmail: commonUrl + 'Account/NotifyEmail', //获取订单提醒邮箱号码
             updateNotifyPhone: commonUrl + 'Account/ChangeOrderNotifyPhone', //修改订单提醒电话

             //预约核销
             getLimitList: commonUrl + 'CQGLimit/List', //获取预约核销列表
             createLimit: commonUrl + 'CQGLimit/Create', //创建核销

             //长轮询
             notifications: commonUrl + 'Orders/Notifier/notifications', //新单通知


             getCheckCode: commonUrl + 'Data/Captcha', //获取验证码

             imgUrl: 'http://sz.cnbooking.net/'
         }


// WEBPACK FOOTER //
// ./src/common/ApiFactory.js